import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router";
import App from "./app";
import { Home } from "./home";
import ShareableComponent from "./sharing";
import { Menu } from "./menu";
import { Artist } from "./artist";
import { TopArtist } from "./topArtist";
import { TopArtistList } from "./topArtistList";
import { Compatibility } from "./compat/compat";
import { Validation } from "./validation/validation";
import { Stats } from "./stats/stats";
import { Thanks } from "./thanks/thanks";
import { Intro } from "./intro";
import { DataProvider } from "./data/dataContext";
import DataFetcher from "./data/dataFetcher";
import { CuriosityFlow } from "./curiosity/curiosity";
import { MusicPlayerProvider, useMusicPlayer } from "./music/musicPlayerContext";

import "./fonts.css"; // Custom styles for the app
import "./assets/css/satoshi.css"; // Custom styles for the app
import "./assets/css/monument.css"; // Custom styles for the app

const root = document.getElementById("root");

const useRootClass = () => {
  const location = useLocation();

  useEffect(() => {
    const rootElement = document.getElementById("root");
    const path = location.pathname.slice(1) || "home"; // Remove the slash or default to "home"
    rootElement.className = `${path}-screen fixed-screen`;
    if (path == "menu") {
      rootElement.className = `${path}-screen scrollable-screen`;
    }
  }, [location]);
};

const AppRoute = () => {
  useRootClass();

  const { pauseMusic } = useMusicPlayer();
  useEffect(() => {
    window.airbudsMessage = function(message) {
      try {
        const json = JSON.parse(message);
        if (json.hasOwnProperty("enterBackground")) {
          pauseMusic();
        }
      } catch (error) {
        console.log("failed to parse incoming message", message);
      }
    }
  }, []);

  return (
    <Routes>
      <Route index element={<App />} />
      <Route path="home" element={<Home />} />
      <Route path="intro" element={<Intro />} />
      <Route path="sharing" element={<ShareableComponent />} />
      <Route path="menu" element={<Menu />} />
      <Route path="artist" element={<Artist />} />
      <Route path="artist-top" element={<TopArtist />} />
      <Route path="artist-top-list" element={<TopArtistList />} />
      <Route path="compat" element={<Compatibility />} />
      <Route path="validation" element={<Validation />} />
      <Route path="stats" element={<Stats />} />
      <Route path="thanks" element={<Thanks />} />
      <Route path="curiosity" element={<CuriosityFlow />} />
    </Routes>
  );
};

ReactDOM.createRoot(root).render(
  <DataProvider>
    <MusicPlayerProvider>
      <BrowserRouter>
        <DataFetcher />
        <AppRoute />
      </BrowserRouter>
    </MusicPlayerProvider>
  </DataProvider>
);
